export default "__VITE_ASSET__acf97f7a__"